var map = {
	"./Project.css": 1710,
	"./Projects": 4955,
	"./Projects.js": 4955,
	"./images/algo-visualizer.jpeg": 9647,
	"./images/apple-clone.png": 5627,
	"./images/ecommerce.jpg": 204,
	"./images/foodie.jpg": 1576,
	"./images/weatherapp.png": 7303
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3141;